module.exports = __webpack_public_path__ + "img/thaipost.f44555ee.png";